module.exports = __webpack_public_path__ + "static/covid-19-thumbnail-c0ed18a5c1f7092aa6e414885654fa5f.jpeg";